export enum WorkStationTypeEnum {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
    INDENT = 'INDENT',

}